module.exports = __webpack_public_path__ + "img/copy.2d259382.png";